const company_config = {
    // GENERAL INFO
    company_name:"UDCL",
    name : {
        arabic: 'UDCL',
        english: 'UDCL',
    },
    description: {
        arabic: 'بايلون هي عبارة عن منصة شاملة لإدارة المرافق تعمل على تحويل مرافق المياه و الكهرباء التقليدية في الأسواق الناشئة إلى أسواق فعالة وقابلة للتشغيل البيني و قائمة على البيانات ',
        english: 'Pylon is a comprehensive utility management platform transforming converntional Water and electricity utilities in emerging markets into efficient, interoperable and data driven ones. ',
    },
    logo_path : {
        arabic: 'UDCL/logo/footer-logo.png',
        english: 'UDCL/logo/footer-logo.png',
        footer_arabic: 'UDCL/logo/footer-logo.png',
        footer_english: 'UDCL/logo/footer-logo.png',
        dark_logo_ar:'UDCL/logo/dark-logo.png',
        dark_logo_en:'UDCL/logo/dark-logo.png',
    },
    customer_service_numbers : [
        '01111919670',
    ],
    customer_service_emails : [
        'info@pylonump.com',
    ],
    socialmedia: [
        // {
        //     type: 'facebook',
        //     url: 'https://web.facebook.com/mostakbalcityofficial/',
        //     name: 'Mostakbalcityofficial'
        // },
        // {
        //     type: 'instagram',
        //     url: 'https://www.instagram.com/mostakbal_city_official/',
        //     name: 'Mostakbalcityofficial'
        // },
        // {
        //     type: 'twitter',
        //     url: 'https://twitter.com/Mostakbal_city',
        //     name: '@Mostakbal_City'
        // },
        {
            type: 'LinkedIn',
            url: 'https://www.linkedin.com/company/pylonump/',
            name: 'PYLON company'
        },
        {
            type: 'email',
            url: 'info@pylonump.com',
            name: 'info@pylonump.com'
        },
        
    ],
    showLocationDetails:true,
    locations: {
        ar:['أركان بلازا - مبنى 4 - الدور الرابع','الشيخ زايد, الجيزة'],
        en:['Arkan Plaza - Building no.(4) - 4th Floor',', Sheikh Zayed City, Giza']
    },
    location_map:"Mostakbal City electricity company",
    location_map_link:"https://www.google.com/maps/place/Pylon/@30.0203759,31.0035838,15z/data=!4m6!3m5!1s0x14585b0d6f68e655:0x4eb5d3c6a34b6e77!8m2!3d30.0203759!4d31.0035838!16s%2Fg%2F11kj88rwsx?entry=ttu",  
    colors: [
        '#e94c28',
        '#002751',
        '#2870b9'
    ],
    PortalLangs:{
        firstLang:'ع',
        secondLang:'En'
    },
    defaultLang:2,
    currency_en:'UGX',
    currency_ar:'UGX',
    // LOGIN PAGE
    unAuth_request:true,
    login_faq:false,
    aboutus:false,
    fastRecharge:true,
    fastRecharge_elements:{
        unit_code:false, // changed to account_reference
        account_reference: true,
        meter_code:true,
        phone_number:false,
        amount:true,
        meter_placeholder_ar:"مثال 123456",
        meter_placeholder_en:"e.g. 123456",
        unit_placeholder_ar:"", // changed to account_reference_placeholder_ar
        unit_placeholder_en:"", // changed to account_reference_placeholder_en
        account_reference_placeholder_ar:"مثال EARKGSB13100",
        account_reference_placeholder_en:"e.g. EARKGSB13100",
        phone_number_placeholder_en:"e.g 01234567890",
        phone_number_placeholder_ar:"مثال 01234567890",
    },
    fastRechargeLimit:{
        min:1,
        max:50000,
    },

    first_login_pass_msg_en:"",
    first_login_pass_msg_ar:"",
    
    forgot_pass:true,

    login_footer:true,
    numberOfLoginFooterElements:4,
    login_footer_elements:{
        numbers:true,
        email:true,
        location:true,
        headQuarters:true,
    },

    
    // NAVBAR
    requests:false,
    faq:false,
    notifications:false,
    raise_complaint_inquiry:false,
    guide:true,
    // FOOTER
    mobile_app:true,
    mobile_app_QRs:{
        ios:'https://apps.apple.com/eg/app/pylon/id6467193423',
        android:'https://play.google.com/store/apps/details?id=com.elsewedyintel',
    },
    footer_back_img_path:'',

     // about us
     about_paragrh:{
        ar:"",
        en:"",   
    },
    about_img_src:'',
    // HOME PAGE

    // meter section 
    remaining_credit:true,
    last_update_date_time:true,
    consumption_chart:true,
    recharge_from_home:false,

    // payment histroy section 
    payment_history_table:false,
    payment_receipt_history_table:true,

    //consumption section
    consumption_history_table:true,
 
    // recharging
    paytabs:false,
    nbe:true,
    nbeVersion:"61",
    response_type:'json',
    enter_total_recahrge_due:false,
    allow_recharge_without_pay_all:false,
    force_pay_all:true,
    show_due_payments:true,
    fees_precentage:0.025,
    fixed_fees:0,
    failure_Recharge_msg_ar:"فشلت بسبب فشل الإتصال بالعداد. الرجاء الاتصال بدعم العملاء على ",
    failure_Recharge_msg_en:"failed due to a failure in communication with the meter. Please contact the customer support on ",
    Invoice_img:'National_Bank_of_Egypt_Logo.png',
    
    // guide page
    show_elec_params_table:false,
    // PROFILE

    // personal info
    changePass:true,
    addEmailToContactInfoMsg:false,

    // notification
    show_critical_part:false,
    notfication_settings:false,
    notfication_settings_elements:{
     sms:true,
     mobile_app:true,
     customer_portal:true,
     email:true
    },
    
       
}

export default  {company_config}
